import { render, staticRenderFns } from "./htmlGameForm1.vue?vue&type=template&id=15a4f2fe&"
import script from "./htmlGameForm1.vue?vue&type=script&lang=js&"
export * from "./htmlGameForm1.vue?vue&type=script&lang=js&"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./htmlGameForm1.vue?vue&type=style&index=1&id=15a4f2fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports